export const DICT = {
  en: {
    tagline: "People · Places · Opportunities",
    join: "Join",
    member_login: "Member Login",
    private_club: "Private Members Club",
    adults_only: "Membership is private, for adults aged 21+, and requires approval.",
    enter: "Enter",
    corporate: "Corporate",
    a_different_perspective: "A Different Perspective",
    // nav
    home: "Home", my_card: "My Card", events: "Events", news: "News", profile: "Profile", membership: "Membership",
    // auth
    email: "Email", password: "Password", sign_in: "Sign In", signing_in: "Signing in…",
    forgot_password: "Forgot password?", back_to_sign_in: "Back to sign in",
    no_account: "Not a member yet?", apply_now: "Apply for membership",
    reset_password: "Reset Password", new_password: "New Password", send_reset_link: "Send reset link",
    reset_sent: "If that email is registered, a reset link has been sent.",
    // application
    application: "Membership Application", first_name: "First Name", surname: "Surname",
    date_of_birth: "Date of Birth", phone: "Mobile / WhatsApp", country: "Country", city: "City",
    profile_photo: "Profile Photograph", preferred_city: "Preferred Caught Up Community",
    how_discovered: "How did you discover Caught Up?", introduction: "Short Introduction (optional)",
    accept_terms: "I accept the Membership Terms.",
    accept_privacy: "I accept the Privacy & Data Protection information.",
    confirm_adult: "I confirm I am aged 21 or over.",
    submit_application: "Submit Application", submitting: "Submitting…",
    already_member: "Already have an account?",
    upload_photo: "Upload photograph", change_photo: "Change photograph",
    // status
    status_pending_title: "Application Under Review",
    status_pending_body: "Thank you for applying. Our committee is reviewing your application. You will be notified by email once a decision has been made.",
    status_payment_title: "Approved — Payment Pending",
    status_payment_body: "Welcome. To activate your annual membership, please complete payment below.",
    status_suspended_title: "Membership Unavailable",
    status_suspended_body: "Your membership is not currently active. Please contact us for assistance.",
    status_expired_title: "Membership Expired",
    status_expired_body: "Your membership has expired. Please renew to restore access.",
    sign_out: "Sign Out",
    // payment
    annual_membership: "Annual Individual Membership", pay_with_sumup: "Pay with SumUp",
    scan_to_pay: "Scan to Pay", bank_transfer: "Bank Transfer", your_reference: "Your Payment Reference",
    notify_paid: "I have paid — notify the team", notified: "Payment notification sent",
    account_name: "Account Name", iban: "IBAN", bic: "BIC / SWIFT",
    // card
    valid_until: "Valid Until", member_no: "Member No.", member_since: "Member Since",
    verification: "Verification QR", show_at_venue: "Present at partner venues for access.",
    verify_title: "Membership Verification", verify_valid: "Valid Member", verify_not_valid: "Not Valid", verify_not_found: "Not Recognised", verify_footer: "Admission Verification",
    // events
    upcoming_events: "Upcoming Events", no_events: "No events scheduled yet.",
    rsvp: "Request Attendance", rsvp_requested: "Attendance Requested", rsvp_confirmed: "Confirmed",
    member_price: "Member", guest_price: "Guest", capacity: "Capacity", rsvp_by: "RSVP by",
    private_location: "Private location revealed to confirmed attendees.",
    location: "Location",
    // news
    latest_news: "Club News", no_news: "No announcements yet.",
    // profile
    contact_information: "Contact Information", membership_details: "Membership Details",
    status: "Status", joining_date: "Joining Date", renewal_date: "Renewal Date",
    save_changes: "Save Changes", saved: "Saved",
    // ceo
    international_ceo: "International CEO",
    ceo_statement: "Caught Up International is built on discretion, taste and the quiet power of the right introductions. We do not open doors for everyone — only for those who understand the value of being understood.",
    message_us: "WhatsApp — Message Us",
    // corporate
    corporate_info: "Corporate Information", registered_company: "Registered Company",
    company_no: "Companies House No.", registered_office: "Registered Office",
    official_email: "Official Email", website: "Website",
    membership_terms: "Membership Terms", terms_conditions: "Terms & Conditions",
    privacy_policy: "Privacy & Data Protection", cookie_info: "Cookie Information", contact: "Contact",
    all_rights: "All Rights Reserved",
    // admin
    admin: "Admin", dashboard: "Dashboard", members: "Members", settings: "Settings",
    active_members: "Active Members", pending_applications: "Pending Applications",
    awaiting_payment: "Awaiting Payment", expiring_soon: "Expiring Soon", event_rsvps: "Event RSVPs",
    approve: "Approve", reject: "Reject", confirm_payment: "Confirm Payment", suspend: "Suspend",
    renew: "Renew", activate: "Activate", edit: "Edit", search: "Search members…",
    create_event: "Create Event", create_news: "Create News Post", save: "Save", cancel: "Cancel",
    delete: "Delete", title: "Title", description: "Description", image: "Image",
    public_venue: "Public Venue Info", private_venue: "Private Venue (confirmed only)",
    datetime: "Date & Time", rsvp_deadline: "RSVP Deadline", view_rsvps: "View RSVPs",
    confirm: "Confirm", all: "All",
  },
  it: {
    tagline: "Persone · Luoghi · Opportunità",
    join: "Iscriviti",
    member_login: "Accesso Soci",
    private_club: "Club Privato per Soci",
    adults_only: "L'iscrizione è privata, riservata ai maggiori di 21 anni e soggetta ad approvazione.",
    enter: "Entra",
    corporate: "Societario",
    a_different_perspective: "Una Prospettiva Diversa",
    home: "Home", my_card: "La Mia Tessera", events: "Eventi", news: "Notizie", profile: "Profilo", membership: "Iscrizione",
    email: "Email", password: "Password", sign_in: "Accedi", signing_in: "Accesso…",
    forgot_password: "Password dimenticata?", back_to_sign_in: "Torna all'accesso",
    no_account: "Non sei ancora socio?", apply_now: "Richiedi l'iscrizione",
    reset_password: "Reimposta Password", new_password: "Nuova Password", send_reset_link: "Invia link",
    reset_sent: "Se l'email è registrata, è stato inviato un link di reimpostazione.",
    application: "Domanda di Iscrizione", first_name: "Nome", surname: "Cognome",
    date_of_birth: "Data di Nascita", phone: "Cellulare / WhatsApp", country: "Paese", city: "Città",
    profile_photo: "Fotografia Profilo", preferred_city: "Comunità Caught Up Preferita",
    how_discovered: "Come hai scoperto Caught Up?", introduction: "Breve Presentazione (facoltativa)",
    accept_terms: "Accetto i Termini di Iscrizione.",
    accept_privacy: "Accetto le informazioni su Privacy e Protezione Dati.",
    confirm_adult: "Confermo di avere 21 anni o più.",
    submit_application: "Invia Domanda", submitting: "Invio…",
    already_member: "Hai già un account?",
    upload_photo: "Carica fotografia", change_photo: "Cambia fotografia",
    status_pending_title: "Domanda in Revisione",
    status_pending_body: "Grazie per la tua domanda. Il nostro comitato la sta esaminando. Riceverai una notifica via email.",
    status_payment_title: "Approvato — Pagamento in Attesa",
    status_payment_body: "Benvenuto. Per attivare l'iscrizione annuale, completa il pagamento qui sotto.",
    status_suspended_title: "Iscrizione Non Disponibile",
    status_suspended_body: "La tua iscrizione non è attualmente attiva. Contattaci per assistenza.",
    status_expired_title: "Iscrizione Scaduta",
    status_expired_body: "La tua iscrizione è scaduta. Rinnova per ripristinare l'accesso.",
    sign_out: "Esci",
    annual_membership: "Iscrizione Annuale Individuale", pay_with_sumup: "Paga con SumUp",
    scan_to_pay: "Scansiona per Pagare", bank_transfer: "Bonifico Bancario", your_reference: "Il Tuo Riferimento",
    notify_paid: "Ho pagato — avvisa il team", notified: "Notifica di pagamento inviata",
    account_name: "Intestatario", iban: "IBAN", bic: "BIC / SWIFT",
    valid_until: "Valida Fino al", member_no: "N. Socio", member_since: "Socio Dal",
    verification: "QR di Verifica", show_at_venue: "Presenta nei locali partner per l'accesso.",
    verify_title: "Verifica Iscrizione", verify_valid: "Socio Valido", verify_not_valid: "Non Valido", verify_not_found: "Non Riconosciuto", verify_footer: "Verifica Ammissione",
    upcoming_events: "Prossimi Eventi", no_events: "Nessun evento in programma.",
    rsvp: "Richiedi Partecipazione", rsvp_requested: "Partecipazione Richiesta", rsvp_confirmed: "Confermato",
    member_price: "Socio", guest_price: "Ospite", capacity: "Capienza", rsvp_by: "RSVP entro",
    private_location: "Luogo privato rivelato ai partecipanti confermati.",
    location: "Luogo",
    latest_news: "Notizie del Club", no_news: "Nessun annuncio.",
    contact_information: "Informazioni di Contatto", membership_details: "Dettagli Iscrizione",
    status: "Stato", joining_date: "Data Iscrizione", renewal_date: "Data Rinnovo",
    save_changes: "Salva Modifiche", saved: "Salvato",
    international_ceo: "International CEO",
    ceo_statement: "Caught Up International si fonda sulla discrezione, sul gusto e sul potere silenzioso delle presentazioni giuste. Non apriamo le porte a tutti — solo a chi comprende il valore di essere compresi.",
    message_us: "WhatsApp — Scrivici",
    corporate_info: "Informazioni Societarie", registered_company: "Società Registrata",
    company_no: "N. Companies House", registered_office: "Sede Legale",
    official_email: "Email Ufficiale", website: "Sito Web",
    membership_terms: "Termini di Iscrizione", terms_conditions: "Termini e Condizioni",
    privacy_policy: "Privacy e Protezione Dati", cookie_info: "Informazioni Cookie", contact: "Contatti",
    all_rights: "Tutti i Diritti Riservati",
    admin: "Admin", dashboard: "Pannello", members: "Soci", settings: "Impostazioni",
    active_members: "Soci Attivi", pending_applications: "Domande in Attesa",
    awaiting_payment: "In Attesa di Pagamento", expiring_soon: "In Scadenza", event_rsvps: "RSVP Eventi",
    approve: "Approva", reject: "Rifiuta", confirm_payment: "Conferma Pagamento", suspend: "Sospendi",
    renew: "Rinnova", activate: "Attiva", edit: "Modifica", search: "Cerca soci…",
    create_event: "Crea Evento", create_news: "Crea Notizia", save: "Salva", cancel: "Annulla",
    delete: "Elimina", title: "Titolo", description: "Descrizione", image: "Immagine",
    public_venue: "Info Luogo Pubblico", private_venue: "Luogo Privato (solo confermati)",
    datetime: "Data e Ora", rsvp_deadline: "Scadenza RSVP", view_rsvps: "Vedi RSVP",
    confirm: "Conferma", all: "Tutti",
  },
};
